<template>
  <app-filter-group
      :isBr="false"
      @query="querySearch"
      :query-loading="queryLoading"
      @reset="reset">
    <gj-country-server-select
        v-model="filter.countryAndMarket"
    ></gj-country-server-select>
    <gj-select
        v-if="showCurrency"
        v-model="filter.currency"
        :options="option.statisticsCurrency"
        :clearable="false"
        style="margin-left: 8px"
    ></gj-select>
    <gj-date-picker
        v-model="filter.date"
        type="daterange"
        :clearable="false"
        :max-day-length="60"
    ></gj-date-picker>
    <slot></slot>
    <template #right>
      <slot name="right"></slot>
      <view-setting
              :ref="REF_VIEW_SETTING"
              save-mode="remote"
              :use-default="true"
              :module-name="moduleName"
              :config="model"
              :fn-generate-params="generateViewParams"
              @view-change="handleChangeView"
              @view-complete="handCompleteView"
      >

      </view-setting>
    </template>
  </app-filter-group>
</template>

<script>
  import {financeCurrencysOption} from "@/utils/options";
  import {convertToDate, generateViewParams} from "@/utils/date.util";
  import {DATE_SHORTCUTS} from "@/utils/const";
  import viewConfig from './viewConfig'
  import { queryMixin, noRepeatQueryMixin } from "@/minxins";

  export default {
    name: "market-analysis-filter",
    props: {
      showCurrency: {
        type: Boolean,
        default: true
      },
      queryLoading: {
        default: false
      },
      paginations: {
        type: Object,
        default: () => ({})
      }
    },
    mixins: [queryMixin, noRepeatQueryMixin],
    data() {
      return {
        filter: {
          countryAndMarket: null,
          currency: '',
          date: DATE_SHORTCUTS.last14Day.date,
          userPermission: null,
        },
        option: {
          statisticsCurrency: financeCurrencysOption,
        },
        viewConfig
      }
    },
    created() {

    },
    computed: {
      model ({ viewConfig, showCurrency }) {
        const model = viewConfig.call(this)
        return model.filter(v => (v.prop !== 'currency' || showCurrency))
      },
      moduleName () {
        return `MARKET_ANALYSIS_FILER_${this.$route.name}`
      }
    },
    methods: {
      /**
       *
       * @param params 查询条件参数
       * @override queryMixin
       * @returns {{countryAndMarket: *}}
       */
      $gjCacheCallback(params) {
        return {
          countryAndMarket: params.countryAndMarket
        };
      },
      generateViewParams,
      handCompleteView(view) {
        const cacheParams = this.getCacheData()
        if (cacheParams && cacheParams.query) {
          this.mergeRemoteParams(cacheParams.query)
          this.$emit('set-pagination', cacheParams.pagination || {})
          this.search()
        } else {
          if (view && view.params) {
            try {
              let params = JSON.parse(view.params)
              if (params && this.mergeRemoteParams && typeof this.mergeRemoteParams === 'function') {
                this.mergeRemoteParams(params)
              }

              this.search()
            } catch (e) {
              console.warn(e)
            }
          } else {
            this.reset()
          }
        }
      },
      /**
       * 切换视图
       */
      async handleChangeView (view) {
        if (view && view.params) {
          try {
            let params = JSON.parse(view.params)
            if (params && this.mergeRemoteParams && typeof this.mergeRemoteParams === 'function') {
              this.mergeRemoteParams(params)
            }

            this.search()
          } catch (e) {
            console.warn(e)
          }
        } else {
          this.reset()
        }

      },
      /**
       * 设置全局查询参数
       */
      mergeRemoteParams (params) {
        const date = params.date ? params.date : (params.startDateTime && params.endDateTime ? [params.startDateTime, params.endDateTime] : this.filter.date)
        Object.assign(this.filter, {
          ...params,
          date
        })
      },
      search(type = 'search', useCache = false) {
        const params = {
          startStatisticsDate: convertToDate(this.filter.date[0]),
          endStatisticsDate: convertToDate(this.filter.date[1]),
          userPermission: this.filter.userPermission,
          currency: this.filter.currency,
        };
        if (this.filter.countryAndMarket) {
          params.countrys = this.filter.countryAndMarket.countryIds;
          params.marketIds = this.filter.countryAndMarket.marketIds;
        }
        if (useCache) {
          this.setCacheDatas()
        }
        this.$emit(type, params);
      },
      querySearch() {
        this.search('search', true)
      },
      reset() {
        this.filter.currency = '';
        this.filter.date = DATE_SHORTCUTS.last14Day.date;
        this.filter.userPermission = null;
        if (this.filter.countryAndMarket) {
          this.filter.countryAndMarket = null;
        }
        this.search('reset')
      },
      setCacheDatas() {
        this.pagination = {...this.paginations}
        this.setCacheData()
      }
    }
  }
</script>

<style scoped>

</style>
